import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import httpClient from "@/tools/http-client";

export const DEFAULT_ACQUIRED_COINS_PER_PAGE = 12;

export const useAcquiredCoinsStore = defineStore('acquiredCoinsStore', () => {
    const endpoint = environment.appConfig.baseApiUrl + "profile/coins";
    const crud = useCrudStore(endpoint);

    async function loadData(metaParams) {
        crud.startLoading();
        try {
            metaParams.page = Number(metaParams.page || 0) + 1;
            metaParams.per_page = Number(metaParams.per_page || DEFAULT_ACQUIRED_COINS_PER_PAGE);

            const response = await httpClient.get(endpoint, {params: metaParams});
            if (response.data.status === 'error') {
                crud.setError(response.data.message);
                return;
            }
            crud.addItems(response.data.coins || []);
            crud.clearLoading();
        } catch (error) {
            crud.setError(error);
        }
    }

    return {
        ...crud,
        loadData,
    };
});
